(function (angular) {
	'use strict';

	angular
		.module('investorDashboard')
		.controller('DashboardPosition', [
			'$filter',
			'APP_BASE_PATH',
			'DashboardPerformanceService',
			'globalConfig',
			'mixpanelFactory',
			'ReitElementFactory',
			DashboardPositionFunction
		]);

	function DashboardPositionFunction(
		$filter,
		APP_BASE_PATH,
		DashboardPerformanceService,
		globalConfig,
		mixpanelFactory,
		ReitElementFactory) {
		
		var dashboard = this;
		dashboard.basePath = APP_BASE_PATH;

		dashboard.$onInit = function() {
			angular.extend(dashboard, globalConfig);

			dashboard.loadingPerformance = true;

			ReitElementFactory.getReitElementsForReit(dashboard.reitId, ['weightedReitElementsByStatus'])
				.then(function(reitElementLists) {
					dashboard.reitElementsForReit = reitElementLists.weightedReitElementsByStatus;
					dashboard.reitElementsForReit.active = $filter('orderBy')(dashboard.reitElementsForReit.active, 'riskScore');
					dashboard.reitElementsForContainer = angular.copy(reitElementLists.weightedReitElementsByStatus);
				});

			ReitElementFactory.getReitElementListsForDashboard()
				.then(function(reitElementLists) {
					angular.extend(dashboard, reitElementLists);
				});

			DashboardPerformanceService.getReitPositionData(dashboard.reitId)
				.then(function(reitPositionData) {
					dashboard.reitPosition = reitPositionData;
					dashboard.loadingPerformance = false;

					if(angular.isUndefined(dashboard.reitPosition.reitPercentageOfPortfolio)) {
						dashboard.reitPosition.reitPercentageOfPortfolio = '0';
					}		

					dashboard.dividends = {
						name: 'Dividends',
						expanded: false
					};

					dashboard.unrealizedGainLoss = {
						name: 'Unrealized Gain / Loss',
						expanded: false
					};

					dashboard.realizedGainLoss = {
						name: 'Realized Gain / Loss',
						expanded: false
					};
				});
		};

		dashboard.toggleTableSection = function(section) {

			section.expanded = !section.expanded;

			mixpanelFactory.track('Expandable Table - Toggle Section', {
				'Table': 'Your Returns',
				'Section': section.name,
				'Expand': section.expanded
			});
		};
	}
})(window.angular);